import { useEffect, useState } from "react";
import * as React from "react";

export function useDebounce<T>(state: T, delayMilliseconds = 500): T {
    const [debouncedValue, setDebouncedValue] = useState(state);
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(state), delayMilliseconds);
        return () => clearTimeout(timer);
    }, [state, delayMilliseconds]);
    return debouncedValue;
}

export function wrap(...parents: any[]) {
    return function wrapper(child: React.ReactElement | React.ComponentType<any>, props?: any) {
        return parents.reduceRight((acc, cur) => {
            if (Array.isArray(cur)) {
                return React.createElement(cur[0], cur[1], acc);
            }
            return React.createElement(cur, null, acc);
        }, React.isValidElement(child) ? child : React.createElement(child as React.ComponentType<any>, props));
    };
} 